import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgxPermissionsModule, NgxPermissionsService, NgxRolesService } from "ngx-permissions";
import { LocalStorageService } from "./local-storage/local-storage.service";
import { LoginGuardService } from "./auth/login-guard.service";
import { AppInitializerProvider } from "../app-initializer.service";
import { NZ_I18N, pt_BR } from "ng-zorro-antd/i18n";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { AuthGuardService } from "./auth/auth-guard.service";
import { httpInterceptorProviders } from "./http-interceptors";
import { AuthorizationGuard } from "./auth/authorization-guard.service";
import { NZ_CONFIG, NzConfig } from "ng-zorro-antd/core/config";

// const ngZorroConfig: NzConfig = {
//   theme: {
//     primaryColor: '#1890ff'
//   }
// };
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxPermissionsModule.forRoot(),
  ],
  exports: [
    NgxPermissionsModule,
  ],
  providers: [
    LocalStorageService,
    NgxPermissionsService,
    AuthGuardService,
    LoginGuardService,
    AuthorizationGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: loadPermissions,
      deps: [NgxPermissionsService, LocalStorageService],
      multi: true
    },
    httpInterceptorProviders,
    AppInitializerProvider,
    { provide: NZ_I18N, useValue: pt_BR },
    // { provide: NZ_CONFIG, useValue: ngZorroConfig }
  ]
})
export class CoreModule { }

export function loadPermissions(permissionService: NgxPermissionsService, roleService: NgxRolesService, localStorageService: LocalStorageService) {
  return () => {
    // const userData = localStorageService.getItem('currentUser');

    // if (userData) {
    //   if (userData?.grupo) {
    //     addRolesAcesso();
    //     addPermissoesAcesso();
    //   }
    // }

    // function addRolesAcesso() {
    //   const permissions: string[] = [];
    //   const role = userData.grupo?.descricao;
    //   userData.grupo?.idsPermissaoXObjeto?.forEach((permission: any) => permissions.push(permission));
    //   roleService.addRole(role, permissions);
    // }

    // function addPermissoesAcesso() {
    //   const permissions = <any>sessionStorage.getItem('permissions');
    //   if (permissions) {
    //     permissionService.loadPermissions(JSON.parse(permissions))
    //   }
    // }
  }
}
